/**
 * Der Knopf zum Sprechen (FR-25) — **Tippen an, Tippen aus.**
 *
 * Vorher musste man ihn gedrückt halten. Auf dem Telefon war das mühsam: Der
 * Daumen liegt auf dem Glas, während man spricht und gleichzeitig auf den
 * Stand schauen will. Jetzt: einmal tippen, sprechen, noch einmal tippen.
 *
 * Was gleich bleibt, ist die Regel dahinter: Das Mikrofon ist nur offen, wenn
 * der Besucher es ausdrücklich geöffnet hat, und es schließt sich von selbst,
 * sobald K4ia antwortet — dann muss niemand daran denken, und ihre Stimme
 * läuft nicht wieder ins Mikrofon (die Echounterdrückung ist aus, siehe
 * voiceClient.ts). Der Zustand kommt von außen (`offen`), weil genau dieses
 * Schließen nicht vom Knopf ausgeht.
 */
import { useT } from '../lib/i18n'

export function TalkButton({
  offen,
  onStart,
  onStop,
}: {
  offen: boolean
  onStart: () => void
  onStop: () => void
}) {
  const t = useT()
  return (
    <button
      type="button"
      aria-pressed={offen}
      onClick={() => (offen ? onStop() : onStart())}
      // Kein Auswahlmenü, kein Wischen: Auch ein längerer Druck bleibt ein Tippen.
      style={{ WebkitTouchCallout: 'none', WebkitUserSelect: 'none' }}
      className={`touch-none rounded-full border-2 px-6 py-4 text-sm font-medium transition select-none ${
        offen ? 'border-status-active bg-status-active text-white' : 'border-brand text-text'
      }`}
    >
      {offen ? t.talkOpen : t.talkClosed}
    </button>
  )
}
